define(function (require) {
    "use strict";

    var Backbone = require('backbone');
    var AppConfig = require('config/application');

    var sendToLead = function(data) {
        return send('/rest/leads/email', data);
    };

    var sendToContact = function(data) {
        return send('/rest/contacts/email', data);
    };

    var send = function(url, data) {
        return Backbone.ajax({
            url: AppConfig.host + url,
            contentType: 'application/json',
            type: 'POST',
            data: JSON.stringify(data)
        })
    }

    return {
        sendToLead: sendToLead,
        sendToContact: sendToContact,
    }
})